export const routerBasename = (process.env.REACT_APP_ROUTER_BASENAME || "").replace(/\/$/, "");

export const appPath = (path = "/") => {
  if (!routerBasename) return path;
  if (!path.startsWith("/")) return path;
  if (path === "/") return `${routerBasename}/`;
  if (path === routerBasename || path.startsWith(`${routerBasename}/`)) return path;
  return `${routerBasename}${path}`;
};

export const setAppLocation = (path) => {
  window.location.href = appPath(path);
};
